/**
 * permessi.js — chi puo' fare cosa, nel frontend, in un posto solo.
 *
 * Il server e' la protezione (ogni rotta controlla il ruolo); qui si
 * allinea cio' che si mostra, perche' un collegamento che porta a un 403
 * insegna a diffidare dei collegamenti. La regola e' la stessa di
 * puoVedereDettaglio nel backend: un permesso ha UN nome e UN posto, e
 * le schermate lo importano. Non si riscrive `['admin', 'segreteria']`
 * dentro un componente: il 19 settembre 2026 `puoOrganizzare` e' stato
 * dichiarato dentro un componente e usato in un altro, e l'agenda e'
 * andata giu' in render per tre giorni senza che la build dicesse
 * niente.
 */

/* Le schermate del front-desk: cassa, anagrafiche di fatturazione,
   tessera sanitaria, magazzino, orari e stanze. Il backend le riserva ad
   admin e segreteria. Le rotte di App.js e i collegamenti che ci portano
   leggono QUESTO elenco. */
export const FRONT_DESK = ['admin', 'segreteria'];

/* Chi accetta i pazienti (li crea, con i moduli e le firme) ed elimina
   un'anagrafica: segreteria e amministrazione (Alex, 12/10/2026, domanda 18:
   «i medici non accettano pazienti»). E' per RUOLO: un amministratore
   collegato a un medico e' sempre amministratore. Il server la fa rispettare
   (RUOLI_CREA_PAZIENTE in backend/services/anagraficaScrittura.js); qui si
   smette di mostrare le porte chiuse. */
export const puoAccettarePazienti = (ruolo) => FRONT_DESK.includes(ruolo);

/* Chi MODIFICA l'anagrafica di un paziente gia' in archivio: come sopra, piu'
   il medico senior (Alex, 13/10/2026: «anagrafica modificabile anche dal
   medico senior»). Il medico semplice la legge soltanto. Il server la fa
   rispettare (RUOLI_MODIFICA_ANAGRAFICA, stesso file). */
export const puoModificareAnagrafica = (ruolo) =>
  puoAccettarePazienti(ruolo) || ruolo === 'medico_senior';

/** Orari delle agende e stanze: le rotte /orari e /stanze. */
export const puoOrganizzare = (ruolo) => FRONT_DESK.includes(ruolo);
